<div class="flex flex-col max-h-[90vh] overflow-hidden">
    <div class="flex flex-col">
        <!-- Header -->
        <div mat-dialog-title class="flex flex-0 items-center justify-between h-10 p-0">
          <div class="flex flex-col justify-center text-center text-base font-medium">
            Capture Payment <small class="text-sm">Itinerary Reference {{ data.itinerary.reference }}</small>
          </div>
          <button mat-icon-button (click)="close()" [tabIndex]="-1" class="h-8 w-8">
            <mat-icon class="text-current text-lg" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
          </button>
        </div>
      
        <mat-dialog-content class="grid grid-cols-2 gap-4 p-0 max-h-[70vh] overflow-y-auto">
          <!-- Left Side: Capture Payment Form -->
          <div class="mt-6 border border-blue-400 rounded-lg">
            <div class="mt-6 text-center font-bold text-base">Capture Payment</div>
            <div class="p-4">
              <div class="flex flex-col gap-3">
                <!-- Dropdown for Method -->
                <select name="method" [(ngModel)]="view.payment.paymentMethod"
                  class="block w-full rounded-md border border-slate-300 bg-white px-2 py-3 text-sm font-semibold text-gray-500 shadow-sm focus:border-sky-500 focus:outline-none focus:ring-1 focus:ring-sky-500">
                  <option value="" class="font-semibold text-slate-300" disabled selected>Select Payment Method</option>
                  <option *ngFor="let method of view.paymentMethods" [value]="method.id">{{ method.name }}</option>
                </select>
      
                <!-- Date Picker -->
                <input type="date" name="date" [(ngModel)]="view.payment.paymentDate"
                  class="block w-full rounded-md border border-slate-300 bg-white px-2 py-3 text-sm placeholder-slate-400 shadow-sm placeholder:font-semibold placeholder:text-gray-500 focus:border-sky-500 focus:outline-none focus:ring-1 focus:ring-sky-500"
                  placeholder="dd/mm/yyyy" />
      
                <!-- Amount -->
                <input type="number" name="amount" [(ngModel)]="view.payment.baseAmount"
                  class="block w-full rounded-md border border-slate-300 bg-white px-2 py-3 text-sm placeholder-slate-400 shadow-sm placeholder:font-semibold placeholder:text-gray-500 focus:border-sky-500 focus:outline-none focus:ring-1 focus:ring-sky-500"
                  placeholder="Enter amount *" />
      
                <!-- Reference -->
                <input type="text" name="reference" [(ngModel)]="view.payment.referenceNumber"
                  class="block w-full rounded-md border border-slate-300 bg-white px-2 py-3 text-sm placeholder-slate-400 shadow-sm placeholder:font-semibold placeholder:text-gray-500 focus:border-sky-500 focus:outline-none focus:ring-1 focus:ring-sky-500"
                  placeholder="Reference *" />
      
                <!-- Description -->
                <input type="text" name="description" [(ngModel)]="view.payment.description"
                  class="block w-full rounded-md border border-slate-300 bg-white px-2 py-3 text-sm placeholder-slate-400 shadow-sm placeholder:font-semibold placeholder:text-gray-500 focus:border-sky-500 focus:outline-none focus:ring-1 focus:ring-sky-500"
                  placeholder="Description" />
              </div>
      
              <!-- Save Payment Button -->
              <div class="flex flex-col mt-4 text-center">
                <button type="button" class="btn btn-primary text-sm py-2" (click)="savePayment()">Save Payment</button>
                <small class="text-center text-xs mt-1">Once your payment is saved, you will be able to upload proof of payment (recommended).</small>
              </div>
              
              <!-- Proof of Payment Upload -->
              <div class="row mt-4" *ngIf="view.payment.guid">
                <div class="col-sm-12 col-md-12">
                  <div class="form-group">
                    <label class="form-label text-center text-sm font-medium">Proof of Payment</label>
                    <app-uploader *ngIf="view.payment.guid" classWidth="col-md-12" type="payment" group="" [typeIdentifier]="view.payment.guid" [autoReset]="0" description="Drag and drop proof of payment here..."></app-uploader>
                  </div>
                </div>
              </div>
            </div>
          </div>
      
          <!-- Right Side: Payments Captured -->
          <div class="mt-6 border border-gray-300 rounded-lg">
            <div class="mt-6 text-center font-bold text-base">Payments Captured</div>
            <div class="p-4">
              <table class="w-full text-left text-sm">
                <thead>
                  <tr>
                    <th class="border-b border-gray-300 pb-2">Date</th>
                    <th class="border-b border-gray-300 pb-2">Method</th>
                    <th class="border-b border-gray-300 pb-2">Reference</th>
                    <th class="border-b border-gray-300 pb-2">Amount</th>
                    <th class="border-b border-gray-300 pb-2">Status</th>
                    <th class="border-b border-gray-300 pb-2">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of view.itineraryOption?.payments?.content">
                    <td class="border-b border-gray-200 py-2">{{ item.paymentDate || item.createdOn | date:'dd/MM/yyyy' }}</td>
                    <td class="border-b border-gray-200 py-2">
                      {{ item.paymentMethod == 1 ? 'Credit Card' : item.paymentMethod == 2 ? 'EFT' : 'Debit Card' }}
                    </td>
                    <td class="border-b border-gray-200 py-2">{{ item.referenceNumber }}</td>
                    <td class="border-b border-gray-200 py-2">{{ item.baseAmount | currency:'ZAR':'symbol-narrow' }}</td>
                    <td class="border-b border-gray-200 py-2">
                      <span [ngClass]="{'badge-success': item.isComplete, 'badge-danger': !item.isComplete}" class="badge text-xs">
                        {{ item.isComplete ? 'Completed' : 'Failed' }}
                      </span>
                    </td>
                    <td class="border-b border-gray-200 py-2">
                      <button class="text-red-500 hover:text-red-700 font-semibold text-xs" (click)="removePayment(item)">Delete</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </mat-dialog-content>
      
        <mat-dialog-actions align="end" class="p-4">
          <div class="flex justify-center gap-2">
            <button mat-button mat-dialog-close class="text-sm">Cancel</button>
            <button mat-button [mat-dialog-close]="true" cdkFocusInitial (click)="apply()" class="text-sm">Close</button>
          </div>
        </mat-dialog-actions>
      </div>
</div>